import { Check } from 'lucide-react';

/**
 * "Order Received!" badge: a still white tick on the club colour. It replaced
 * a spinner that fans watched, waiting for it to finish (feedback 23 Oct 2026).
 * The green tick is reserved for the end of the order (delivered / collected),
 * so a fan sees white → green as the order completes.
 */
export function OrderReceivedBadge() {
  return (
    <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mb-6 animate-pop-in">
      <Check className="w-10 h-10 text-white" strokeWidth={3} aria-hidden="true" />
    </div>
  );
}
